import PortalRoleTemplatePortalRoleLnkTypes from "../../../types/portalTemplateTypes/PortalRoleTemplatePortalRoleLnkTypes"

const PortalRoleTemplatePortalRoleLnkBoilerplate: PortalRoleTemplatePortalRoleLnkTypes = {
    RoleTemplatePortalRoleLnkId: null,
    RoleTemplateId: null,
    PortalRoleId: null,
    Edit: false,
    View: true,
    CreatedBy: null,
    CreatedDateUTC: null,
    ModifiedBy: null,
    ModifyDateUTC: null,
    DeletedBy: null,
    DeletedDateUTC: null,
    DisabledBy: null,
    DisabledDateUTC: null
}
export default PortalRoleTemplatePortalRoleLnkBoilerplate